// Renovacion silenciosa de la sesion del portal. La implementacion es la
// compartida (@ucorp/web-auth); aca se la ata al store y a la config del
// portal. El operador del proveedor tiene el portal abierto mientras despacha
// y no tiene que caer al login en el medio.
import { createRenewal, createSessionRenewalHook } from "@ucorp/web-auth";
import { readConfig } from "../config.js";
import { POLITICA_MFA } from "./mfa.js";
import { store } from "./session.js";

export const renewal = createRenewal({ store, pool: () => readConfig(), politica: POLITICA_MFA });

/** Mantiene viva la sesion mientras el componente este montado. */
export const useRenovacionDeSesion = createSessionRenewalHook(renewal);

/** Sesion lista para el proximo request (la usara el cliente HTTP de PP-22). */
export const conSesionFresca = renewal.conSesionFresca;
